export default "__VITE_ASSET__LuWSR18m__"